import { useLocation } from "react-router";
import React, { useState, useEffect, useHistory, useRef } from "react";

import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";

import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import jsPDF from "jspdf";
import { Checkbox, Modal } from "antd";
import ReactToPrint from "react-to-print";
import CorporateTransactionss from "../reports/CorporateTransactions";
import ActionButtons from "./TransactionsActionButton.js";
const CorporateTransactions = () => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const getTransactions = async () => {
    const response = await axios
      .get("allCorporateTransactions/", {})
      .then((res) => {
        console.log("======allCorporateTransactions======", res.data);
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger.firstName} ${transaction.passenger.lastName}`;
          const driverName = `${transaction.driver.firstName} ${transaction.driver.lastName}`;

          return {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };
        });

        setTransactions(transactionsWithMergedNames);
        setLoading(false);
        // notify()
      })
      .catch((err) => {
        notifyError();
      });
  };


  const notify = () =>
    toast.success("Vehicles list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);
  const isCompanyUser = typeof window !== 'undefined' && localStorage.getItem('userType') === 'ambulance_company';

  const columns = React.useMemo(
    () => {
      const base = [];

      // Trip ID grouped under Company section for consistency, but hide company details for ambulance company users
      const companyGroup = {
        Header: isCompanyUser ? "Trip" : "Company",
        columns: [
          { Header: "Id", accessor: "id" },
          ...(!isCompanyUser ? [
            { Header: "Company", accessor: "company.companyName" },
            { Header: "Phone", accessor: "company.phoneNumber" },
          ] : []),
        ],
      };

      base.push(companyGroup);

  if (!isCompanyUser) {
      base.push({
        Header: "Passenger",
        columns: [
          { Header: "First Name", accessor: "passenger.firstName" },
          { Header: "Last Name", accessor: "passenger.lastName" },
          { Header: "Phone Number", accessor: "passenger.phoneNumber" },
        ],
      });
    }

      base.push({
        Header: "Driver",
        columns: [
          { Header: "First Name", accessor: "driver.firstName" },
          { Header: "Last Name", accessor: "driver.lastName" },
          { Header: "Phone Number", accessor: "driver.phoneNumber" },
        ],
      });

      base.push({
        Header: "Transactions",
        columns: [
          { Header: "Total Price in ETB", accessor: "trip.actualPrice" },
          { Header: "Revenue in ETB", accessor: "trip.revenue" },
          { Header: "Transaction Date", accessor: "trip.createdAt" },
        ],
      });

      return base;
    },
    [typeof window !== 'undefined' && localStorage.getItem('userType')]
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "driver.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Trip",
          columns: [
            { Header: "Price", accessor: "trip.actualPrice" },
            // { Header: "Revenue", accessor: "trip.revenue" },
            { Header: "PickUp", accessor: "trip.pickUpPlace" },
            { Header: "Destination", accessor: "trip.destinationPlace" },
            { Header: "Date", accessor: "trip.createdAt" },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );
  function handleExportClick(transactions, columns) {
    console.log("handleExportClick called");

    const doc = new jsPDF();

    const imgWidth = 100;
    const imgHeight = 100;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const x = (pageWidth - imgWidth) / 2;
    const y = (pageHeight - imgHeight) / 2;

    doc.addImage("/eTaxi2.png", "PNG", x, y, imgWidth, imgHeight);

    const textX = x + imgWidth / 2;
    const textY = y - 10;

    doc.setFontSize(18);
    doc.text(
      `eTaxi transaction report for company: ${transactions[0].company.companyName}`,
      textX,
      textY,
      {
        align: "center",
      }
    );

    doc.setFontSize(12);

    doc.addPage();

    doc.setFontSize(14);

    const tableData = transactions.map((transaction) =>
      columns.map((column) => {
        if (selectedColumns.includes(column.Header)) {
          const accessorKeys = column.accessor.split("."); // Split nested accessors

          let data = transaction;

          // Traverse through nested objects
          for (const key of accessorKeys) {
            if (data[key] !== undefined) {
              data = data[key];
            } else {
              data = ""; // Handle case where data is missing
              break;
            }
          }

          console.log(`Column: ${column.Header}, Data:`, data); // Debugging
          return data;
        }
      })
    );

    console.log("Table data:", tableData); // Debugging

    const tableWidth = "auto"; // Set the desired table width ('auto' or a specific number)
    const margin = { top: 15, right: 15, bottom: 15, left: 15 }; // Adjust margins as needed

    doc.autoTable({
      head: [
        columns.map((column) => {
          if (selectedColumns.includes(column.Header)) {
            return column.Header;
          }
        }),
      ],
      body: tableData,
      tableWidth,
      // margin,
    });

    // doc.autoTable({
    //   head: [columns],
    //   body: tableData,
    //   tableWidth,
    // });

    doc.save("transaction_list.pdf");
  }

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(transactions, columns_expo);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };
  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                
               
                  <ActionButtons title="Corporate Transactions" showModal={showModal} />
                  <Modal
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                {/* </div> */}

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && <Table columns={columns} data={transactions} title="List of Transactions" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
};

export default CorporateTransactions;
